import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { map, Observable } from 'rxjs';
import { ClientService } from './clients.service';
import { ApiResponseModel } from '../../core/api-response.model';
import { RouteCacheService } from '../../shared/services/route-cache.service';
import { ClientGetDTO, ClientDetailDTO } from './client.model';

@Injectable({ providedIn: 'root' })
export class ClientsResolver implements Resolve<any> {
  clientService = inject(ClientService);
  routeCache = inject(RouteCacheService);

  resolve(
    route: ActivatedRouteSnapshot,
  ): Observable<ApiResponseModel<ClientGetDTO> | ClientDetailDTO> {
    const id = route.paramMap.get('id');
    if (id) {
      return this.clientService.getClientById(id);
    }

    const contextRoute = this.routeCache.getContextRoute(route);
    const gridState = contextRoute?.data?.gridClientState;
    const filters = gridState?.filters ?? {};

    return this.clientService
      .get(undefined, {
        page:
          gridState?.paginator?.pageIndex != null
            ? gridState.paginator.pageIndex + 1
            : 1,
        limit: gridState?.paginator?.pageSize ?? 15,
        ...(filters.name ? { name: filters.name } : {}),
      })
      .pipe(
        map((response) => ({
          ...response,
          data: response.data.map((item) => ({
            ...item,
          })),
        })),
      );
  }
}
